import moment from "moment";
import { BehaviorSubject } from "rxjs";
import { IDataResponse, apiNoLoading, STATUS_CODE } from "src/framework/providers/api";
import { LIST_TIPO_CONTA_DISTRIBUIDORES, LIST_TIPO_CONTA_REVENDAS, TIPO_CONTA_COLABORADOR, TIPO_CONTA_EV } from "src/types";
import { ContaUsuario, VerificarContaInput } from "./global.store.types";
import { Atributo } from "src/providers/cadastros/AtributosProvider";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { carregarFraseParceiroPowerAlert } from "src/components/projetos/utils/showPopupParceiroPowerAlert";
import { RenderPropsSimplificada } from "src/framework/layouts/Main/PropostaSimplificada/types";
import { MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR, MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA } from "src/App";
import { notifierStore } from "src/framework/store/NotifierStore";

export type CacheType<T = any> = {
    expires: number;
    data: T;
    loading: boolean;
}

export const getChacheTime = (customCacheTime?: number): number => {
    return Number(moment().add(customCacheTime || process.env.REACT_APP_ENV_CACHE_EXPIRES, "minute").format("x"))
}

export const mensagemWhatsAppProposta$ = new BehaviorSubject<string>('');
export const pwaPromptEvent$ = new BehaviorSubject<any>(null);

export const MINIO_URL = process.env.REACT_APP_MINIO_UPLOAD_URL || '';

export const STORE_INITIAL_STATE_LIST = {
    data: [],
    expires: 0,
    loading: false,
}

export const estados$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const popups$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const regioes$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const contaUsuario$ = new BehaviorSubject<CacheType<ContaUsuario | null>>({
    data: null,
    expires: 0,
    loading: false,
});

export const cidades$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});


export const grupoEstrutura$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const estruturaDistribuicao$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const limitacoes$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const componentes$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const distribuidores$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const distribuidoresPorTipoDeConta$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const revendas$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const evs$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const engenharia$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const estadosServico$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const filtroSegmentoConta$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});


export const estadosServicoRegioes$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const atributos$ = new BehaviorSubject<CacheType<Atributo[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const termos$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const categorias_componentes$ = new BehaviorSubject<CacheType<any[]>>({
    data: [],
    expires: 0,
    loading: false,
});

export const fraseParceiro$ = new BehaviorSubject<CacheType<string>>({
    data: "",
    expires: 0,
    loading: false,
});

export const propostaSimplificada$ = new BehaviorSubject<CacheType<RenderPropsSimplificada | any>>({
    expires: 0,
    loading: false,
    data: {},
});

export const propostaDetalhada$ = new BehaviorSubject<CacheType<any>>({
    expires: 0,
    loading: false,
    data: {} ,
});


export interface PopupFiltros {
    distribuidor_revenda_id: number
}

export type TUploadConifg = {
    url: string;
    port: string | number;
};

export const resolveUploadUrl = (upload: CacheType<TUploadConifg> | null) => { 
    const uploadConfig = upload?.data || {
        url: "",
        port: ""
    }

    let url: string = uploadConfig?.url || "";

    if (uploadConfig?.port && uploadConfig?.port !== 80) {
      url = `${url}:${uploadConfig["port"]}`;
    }

    if (!url) return process.env.REACT_APP_MINIO_UPLOAD_URL || '';
    return url;
}

export const resolveProtocolUrl = (url?: string): string => {
    if (!url) return '';
    if (url?.includes('data:image')) return url;
    if (url.includes('//undefined')) return url.replace('//undefined', `//${MINIO_URL}`);
    if (url.startsWith('//')) return `${window.location.protocol}${url}`;
    return url;
};

export const getEstados = async ({ force = false }: { force?: boolean } = {}): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = estados$.getValue();

    if ((expires < Number(now) && !loading) || force) {
        estados$.next({ ...estados$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `estados?orderby=nome`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                estados$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }

            estados$.next({
                data: [],
                expires: 0,
                loading: false
            })

            return []
        } catch (error) {
            estados$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return estados$.getValue().data;

}

export const getRegioes = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = regioes$.getValue();
    if (expires < Number(now) && !loading) {
        regioes$.next({ ...regioes$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/cadastros/regioes?includes=estados`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                regioes$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            regioes$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        } catch (error) {
            regioes$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return regioes$.getValue().data;

}


export const getCidades = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading, data } = cidades$.getValue();
    if ((expires < Number(now) || !data?.length) && !loading) {
        cidades$.next({ ...cidades$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `cidades?orderby=estado_id,nome`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                cidades$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return cidades$.getValue().data;
        } catch (error) {
            cidades$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return cidades$.getValue().data;

}

export const getGruposEstrutura = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = grupoEstrutura$.getValue();
    if (expires < Number(now) && !loading) {
        grupoEstrutura$.next({ ...grupoEstrutura$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/estoque/grupos_estruturas?orderby=nome`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                grupoEstrutura$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            grupoEstrutura$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        } catch (error) {
            grupoEstrutura$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return grupoEstrutura$.getValue().data;

}

export const getEstruturasDistribuicao = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = estruturaDistribuicao$.getValue();
    if (expires < Number(now) && !loading) {
        estruturaDistribuicao$.next({ ...estruturaDistribuicao$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/estoque/estruturas?orderby=nome`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                estruturaDistribuicao$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            estruturaDistribuicao$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        } catch (error) {
            estruturaDistribuicao$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return estruturaDistribuicao$.getValue().data;

}

export const getContaUsuario = async() => {
    const { loading } = contaUsuario$.getValue();

    if (!loading) {
        contaUsuario$.next({ ...contaUsuario$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/cadastros/contas/usuario`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data;
                const newExpireDate = getChacheTime()
                contaUsuario$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                mensagemWhatsAppProposta$.next(data?.conta?.mensagem_whatsapp || '')
                return data;
            }
            return contaUsuario$.getValue().data;
        } catch (error) {
            contaUsuario$.next({
                data: null,
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return contaUsuario$.getValue().data;
}

export const getLimitacoesProjetos = async (): Promise<any[]> => {
    const { loading } = limitacoes$.getValue();
    if (!loading) {
        limitacoes$.next({ ...limitacoes$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/limitacoes_projetos/?orderby=descricao`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                limitacoes$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return limitacoes$.getValue().data;
        } catch (error) {
            limitacoes$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return limitacoes$.getValue().data;

}

export const getComponentes = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = componentes$.getValue();
    if (expires < Number(now) && !loading) {
        componentes$.next({ ...componentes$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/estoque/componentes?includes=atributos&reduce`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                componentes$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            componentes$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        } catch (error) {
            componentes$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return componentes$.getValue().data;

}


export const getDistribuidores = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = distribuidores$.getValue();
    if (expires < Number(now) && !loading) {
        distribuidores$.next({ ...distribuidores$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/cadastros/contas?tipo_conta_id_in=${LIST_TIPO_CONTA_DISTRIBUIDORES}&orderby=fantasia`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                distribuidores$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return distribuidores$.getValue().data;
        } catch (error) {
            distribuidores$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }

    }

    return distribuidores$.getValue().data;

}

export const getDistribuidoresPorTipoDeConta = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = distribuidoresPorTipoDeConta$.getValue();
    if (expires < Number(now) && !loading) {
        distribuidoresPorTipoDeConta$.next({ ...distribuidoresPorTipoDeConta$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/cadastros/contas/distribuidores?orderby=fantasia`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                distribuidoresPorTipoDeConta$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }

            distribuidoresPorTipoDeConta$.next({
                data: [],
                expires: 0,
                loading: false
            })
        } catch (error) {
            distribuidoresPorTipoDeConta$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }

    }

    return distribuidoresPorTipoDeConta$.getValue().data;

}

export const getRevendas = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = revendas$.getValue();
    if (expires < Number(now) && !loading) {
        revendas$.next({ ...revendas$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/cadastros/contas?tipo_conta_id_in=${LIST_TIPO_CONTA_REVENDAS}&possue_acesso_solar=true&orderby=nome`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                revendas$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return revendas$.getValue().data;

        } catch (error) {
            revendas$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return revendas$.getValue().data;

}

export const getEvs = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = evs$.getValue();
    if (expires < Number(now) && !loading) {
        evs$.next({ ...evs$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/cadastros/contas?tipo_conta_id_in=${TIPO_CONTA_EV}&possue_acesso_solar=true&orderby=nome`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                evs$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return evs$.getValue().data;
        } catch (error) {
            evs$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return evs$.getValue().data;

}

export const getAnalistasEngenharia = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = engenharia$.getValue();
    if (expires < Number(now) && !loading) {
        engenharia$.next({ ...engenharia$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/cadastros/contas?tipo_conta_id_in=${TIPO_CONTA_COLABORADOR}&possue_acesso_solar=true&orderby=nome`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                engenharia$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return engenharia$.getValue().data;

        } catch (error) {
            engenharia$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return engenharia$.getValue().data;

}
export const getEstadosServico = async ({ force = false }: { force?: boolean } = {}): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = estadosServico$.getValue();
    if ((expires < Number(now) && !loading) || force) {
        estadosServico$.next({ ...estadosServico$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/projetos/servico_estados`,
            });

            if (response.statusCode === STATUS_CODE.OK || response.statusCode === STATUS_CODE.NO_CONTENT) {
                const data = response?.data?.rows || response?.data || [];
                const newExpireDate = getChacheTime()
                estadosServico$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            estadosServico$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        } catch (error) {
            estadosServico$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }
    return estadosServico$.getValue().data;
}

export const getEstadosServicoRegioes = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = estadosServicoRegioes$.getValue();
    if (expires < Number(now) && !loading) {
        estadosServicoRegioes$.next({ ...estadosServicoRegioes$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/projetos/servico_estados?includes=regioes,regioes.estados`,
            });

            if (response.statusCode === STATUS_CODE.OK || response.statusCode === STATUS_CODE.NO_CONTENT) {
                const data = response?.data?.rows || response?.data || [];
                const newExpireDate = getChacheTime()
                estadosServicoRegioes$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            estadosServicoRegioes$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        } catch (error) {
            estadosServicoRegioes$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }
    return estadosServicoRegioes$.getValue().data;
}

/**
 * 
 * @returns Retorna todos os popups da pesquisa na Api.
 */
export const getPopups = async (filtros:PopupFiltros): Promise<any[]> => {
    const permissoes:string[] = PermissionUtil.getPermissions();
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_POPUPS_LISTAGEM, permissoes)) {
        return [];
    }
    const now = moment().format("x")
    const { expires, loading } = popups$.getValue();
    if (expires < Number(now) && !loading) {
        popups$.next({ ...popups$.getValue(), loading: true });
        try {
            const dataAtual = moment(new Date()).format('YYYY-MM-DD');
            let url = `cadastros/popups`;
            url += `?data_inicial_less_equal=${dataAtual}&data_final_more_equal=${dataAtual}`;
            url += `&status=true`;
            url += `&user_id=${filtros.distribuidor_revenda_id}`
            const response: IDataResponse = await apiNoLoading.get({
                url: url
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime(0.01)
                popups$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                
                return data;
            }
            return popups$.getValue().data;
        } catch (error) {
            popups$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }
    return popups$.getValue().data;
}

export const getUpload = async (forceRequest = false): Promise<CacheType | null> => {
    const now = moment().format("x")

    const _cached = LocalStorage.get<CacheType | null>("solar.uploadInfo", true);

    const expires = _cached?.expires || 0;
    const loading = _cached?.loading || false;

    if ((expires < Number(now) && !loading) || forceRequest) {
        LocalStorage.set("solar.uploadInfo", { ..._cached, loading: true }, true)
        const response: IDataResponse = await apiNoLoading.get({
            url: `/uploads`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()

            const cache = {
                data: data,
                expires: newExpireDate,
                loading: false
            }

            LocalStorage.set("solar.uploadInfo", cache, true);
            return cache;
        }
        return null;
    }

    return _cached?.data || null;

}

export const getTermos = async (): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading } = termos$.getValue();
    if (expires < Number(now) && !loading) {
        termos$.next({ ...termos$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/termos?includes=tipos_contas`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                termos$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return termos$.getValue().data;

        } catch (error) {
            termos$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }
    }

    return termos$.getValue().data;
}

export const getCategoriasComponentes = async (forcarCache?: boolean): Promise<any[]> => {
    const now = moment().format("x")
    const { expires, loading, data } = categorias_componentes$.getValue();
    if ((expires < Number(now) || (forcarCache && !data.length)) && !loading) {
        categorias_componentes$.next({ ...categorias_componentes$.getValue(), loading: true })
        try {
            const response: IDataResponse = await apiNoLoading.get({
                url: `/estoque/categorias_componentes`,
            });

            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data?.rows || response.data;
                const newExpireDate = getChacheTime()
                categorias_componentes$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return categorias_componentes$.getValue().data;
        } catch (error) {
            categorias_componentes$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return []
        }

    }

    return categorias_componentes$.getValue().data;

}

export const getFraseParceiro = async (): Promise<string> => {
    const now = moment().format("x")
    const { expires, loading } = fraseParceiro$.getValue();
    if (expires < Number(now) && !loading) {
        fraseParceiro$.next({ ...fraseParceiro$.getValue(), loading: true })
        try {
            const frase = await carregarFraseParceiroPowerAlert();

            if (frase) {
                const data = frase;
                const newExpireDate = getChacheTime()
                fraseParceiro$.next({
                    data: data,
                    expires: newExpireDate,
                    loading: false
                })
                return data;
            }
            return fraseParceiro$.getValue().data;

        } catch (error) {
            fraseParceiro$.next({
                data: "",
                expires: 0,
                loading: false
            })
            return "";
        }
    }

    return fraseParceiro$.getValue().data;
}

export const verificarSegmentoConta = async ({ segmento = 'on', goBack = false, revendaId, distribuidorId }: VerificarContaInput = {}): Promise<boolean> => {
    const { loading } = filtroSegmentoConta$.getValue();
    if (!loading || segmento) {
        filtroSegmentoConta$.next({ ...filtroSegmentoConta$.getValue(), loading: true })
        try {
            let url = `/cadastros/contas/segmento/verificar?segmento=${segmento}`;
            if (revendaId) url += `&revenda_id=${revendaId}`;
            if (distribuidorId) url += `&distribuidor_id=${distribuidorId}`;
            const response: IDataResponse = await apiNoLoading.get({ url });

            if (response.statusCode === STATUS_CODE.OK || response.statusCode === STATUS_CODE.NO_CONTENT) {
                filtroSegmentoConta$.next({
                    expires: 0,
                    loading: false,
                    data: [{ status: true }],
                })
                return true;
            }

            const mensagemSegmentoRevenda = response?.message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA);
            const mensagemSegmentoDistribuidor = response?.message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR);
            if (mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) {
                notifierStore.setNotifier({
                    content: response?.message,
                    title: "Atenção!",
                    timeOut: 3000,
                    onFinishTimeout: () => {
                        notifierStore.setOpen(false);
                        if (goBack) window.location.href = `${window.location.origin}/projetos/menu-projetos`;
                    },
                    onClose: () => {
                        notifierStore.setOpen(false);
                        if (goBack) window.location.href = `${window.location.origin}/projetos/menu-projetos`;
                    },
                });
                notifierStore.setOpen(true);
            }

            filtroSegmentoConta$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return false
        } catch (error) {
            filtroSegmentoConta$.next({
                data: [],
                expires: 0,
                loading: false
            })
            return false
        }
    }
    return !!filtroSegmentoConta$.getValue()?.data?.length;
}

export const getPropostaSimplificada = async (hash: string): Promise<RenderPropsSimplificada | any> => {
    propostaSimplificada$.next({ ...propostaSimplificada$.getValue(), loading: true })
    try {
        const response: IDataResponse = await apiNoLoading.get({
            url: `/projetos/propostas/simplificada/${hash}`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            propostaSimplificada$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return propostaSimplificada$.getValue().data;
    } catch (error) {
        propostaSimplificada$.next({
            data: {},
            expires: 0,
            loading: false
        })
        return {};
    }
}

export const getPropostaDetalhada = async (hash: string): Promise<any> => {
    propostaDetalhada$.next({ ...propostaDetalhada$.getValue(), loading: true })
    try {
        const response: IDataResponse = await apiNoLoading.get({
            url: `/projetos/propostas/detalhada/${hash}`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            const newExpireDate = getChacheTime()
            propostaDetalhada$.next({
                data: data,
                expires: newExpireDate,
                loading: false
            })
            return data;
        }
        return propostaDetalhada$.getValue().data;
    } catch (error) {
        propostaDetalhada$.next({
            data: {},
            expires: 0,
            loading: false
        })
        return {};
    }
}
